import React, {Component} from 'react';
import {SearchBar, Toast,Modal} from 'antd-mobile';
import CityModal from '../../../components/CityModal';
import BMap from "BMap";
import * as mapData from '../../../config/mapData'
import NationalCity from '../../../components/NationalCity';
import {
    endCity,
    getHistoryAddress,
    checkRange,
    getHot,
    cityGetPrice,
    changeAddress,
    getPoi,
    shuttleCheckouts,txgetLocation,txsuggestion
} from '../../../service/homeService';
import "./style.less";
import connect from "react-redux/es/connect/connect";
import Lottie from "react-lottie";
const userPosition = require('../../../common/image/userPosition.png');
let map,point,gc,poi,ls;

@connect(
    state => ({userInfo: state.userInfo})
)
export default class SelAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            position: {top: 0, left: 0,},
            errorTips: [
                '',
                '您当前所在位置超出接送范围！',
                '超出接送范围，请重新选择！',
                '坐标位置',
            ],
            curTips: '',
            isError: false,
            userPoint:'',
            endAddress:'请拖动地图选点',
            searchValue:'',
            poiList:[],
            poiListFlag:true,
            cityModal:false,
            modalType:'end',
            citySearch:'',
            cityData:[],
            currentEndCity:'',
            historyAddress:'',
            isStopped: false,
            hotData:[],
            newHotData:[],
            national:false,
            historyData:[],
        };
    }
    componentDidMount() {
        let props = this.props.location.state;
        console.log(props)
        const self = this;
        map = new window.TMap.Map('mapContainer');
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.SCALE);
        // map = new BMap.Map('mapContainer');
        // gc = new BMap.Geocoder();
        // ls = new BMap.LocalSearch(map, {
        //     onSearchComplete: (res) => {
        //         let s = [];
        //         if(res){
        //             for (var i = 0; i < res.getCurrentNumPois(); i ++){
        //                 s.push(res.getPoi(i))
        //             }
        //             self.setState({
        //                 poiList: s,
        //             });
        //         }
        //     },
        // });
        map.on("panend",function(e){
            let location = map.getCenter().toString().replace(/\s/ig, '')
            self.setState({isStopped:true});
            let params = {
                source: 1,
                token: self.props.userInfo.token,
                data:{location:location.split(',')[0]+','+location.split(',')[1],get_poi:1}
            };
            txgetLocation(params).then((res)=>{
                let result = res.data.data.result
                if (result.poi_count > 0) {
                    let firstPoint = result.pois[0];
                    self.setData(self, firstPoint.title, firstPoint.location.lng, firstPoint.location.lat, true, 0);
                    // self.setState({poiList: result.pois,});
                }
                if (result.poi_count == 0 && result.address_component.street !== "") {
                    self.setData(self, result.address_component.street + result.address_component.street_number, result.location.lng, result.location.lat, true, 0);
                }
                if (result.poi_count == 0 && result.address_component.street == "") {
                    self.setData(self, '坐标位置', result.location.lng, result.location.lat, true, 3);
                }
                self.setState({ isStopped: false });
            })
        })
        // map.addEventListener('dragend', function (e) {
        //     self.setState({isStopped:true});
        //     gc.getLocation(e.point, function (res) {
        //         if (res.surroundingPois.length) {
        //             let firstPoint = res.surroundingPois[0];
        //             self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, true, 0);
        //             self.setState({poiList:res.surroundingPois,});
        //         } else {
        //             self.setData(self, '坐标位置', e.point.lng, e.point.lat, true, 3);
        //         }
        //         self.setState({isStopped:false});
        //     });
        // });
        if(props.cityType === 'intercity'){
            if(props.startCity == '昆明市'){
                this.setState({endAddress:"民途出行北市区集散中心"});
                // map.centerAndZoom(new BMap.Point(102.738151,25.082654), 15);
                map.setCenter(new window.TMap.LatLng(25.082654, 102.738151));
                self.setData(this, "民途出行北市区集散中心", 102.738151,25.082654, true, 0);
            }else{
                map.centerAndZoom(props.startCity, 15);
            }
            this.setState({cityModal:true});
            const params = {
                source: 1,
                token:this.props.userInfo.token,
                data:{
                    // displayName:props.startCity,
                    position:props.startPoi.lat + '_'+ props.startPoi.lng,
                }
            };
            const addressParams = {
                source: 1,
                token:this.props.userInfo.token,
            };

            getHistoryAddress(addressParams).then((res)=>{
                if(res.data.code === '0000'){
                    this.setState({historyAddress:res.data.data[0]})
                }
            });
            getHot(addressParams).then((res)=>{
                if(res.data.code == '0000'){
                    this.getEndCityList(params,res.data.data);
                }
            });
        }else{
            // map.centerAndZoom(props.startCity, 15);
            map.setCenter(new window.TMap.LatLng(props.currentLocation.lat,props.currentLocation.lng));
            this.setState({currentEndCity:props.startCity})
        }

    }

    selPoi(res){
        const props = this.props.location.state;
        this.setData(this, res.title, res.point.lng, res.point.lat, true, 0);
        if(props.cityType === 'intercity'){
            this.intercityCheckRange(props)
        }else if(props.cityType === 'city'){
            this.cityGetPrice(props)
        }else if(props.cityType === 'cityChange'){
            this.cityChangeAddress(props)
        }else if(props.cityType === 'runCar'){
            this.setState({poiListFlag:false});
            map.setCenter(new window.TMap.LatLng(res.point.lat,res.point.lng));
            // map.centerAndZoom(res.point, 15);
        }
    }
    searchChange=(value)=>{
        this.setState({ searchValue:value ,poiListFlag:true});
        this.tabDOM.scrollTop = 0;
        if(value){
            let params = {
                source: 1,
                token: this.props.userInfo.token,
                data:{region:this.state.currentEndCity,keyword:value}
            };
            txsuggestion(params).then((res)=>{
                res.data.data.data.map((r)=>{
                    r.point = r.location
                })
                this.setState({poiList:res.data.data.data,});
            })
        }
        // ls.search(value);
    };
    onClear=()=>{
        this.setState({poiList: [],poiListFlag:false,searchValue:'',});
    };


    // 搜索到达城市(暂时不做)
    searchCity = (v) => {
        this.setState({
            cityData: [],
            citySearch: v,
        });
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                displayName:v
            }
        };
        this.getEndCityList(params);
    };

    onClose = () => {
        this.setState({
            national: false,
            cityModal: false,
            cityData: [],
            citySearch: '',
        });
    };
    toggleCity=()=>{
        const props = this.props.location.state;
        if(props.cityType === "runCar"){
            this.setState({poiList: [],searchValue:'',national: true,});
        }else{
            this.setState({poiList: [],searchValue:'',cityModal: true,});
            const params = {
                source: 1,
                token:this.props.userInfo.token,
                data:{
                    // displayName:props.startCity,
                    position:props.startPoi.lat + '_'+ props.startPoi.lng,
                }
            };
            this.getEndCityList(params);
        }
    };

    getEndCityList = (params,data) => {
        Toast.loading("");
        endCity(params).then((res) => {
            if (res.data.code === '0000') {
                let curList = [];
                let cityName=[];
                for (let k in res.data.data) {
                    curList = curList.concat(res.data.data[k]);
                }
                curList.map((res,i)=>{
                    cityName.push(res.name);
                });
                data.map((n)=>{
                    if(cityName.indexOf(n.name) > -1){
                        //到达：这里就是筛选出来列表中有的，赋值给新的数组展示到热门地州
                        this.state.newHotData.push(n)
                    }
                });
                this.setState({cityData: res.data.data});
                Toast.hide();
            }else{
                Toast.info(res.data.msg,3)
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    changeCity(n){
        this.setData(this, n.address, n.lng,n.lat, true, 0);
        map.setCenter(new window.TMap.LatLng(n.lat,n.lng));
        // map.centerAndZoom(new BMap.Point(n.lng,n.lat),15);
        this.setState({cityModal: false,currentEndCity:n.name,position:{},historyData:n});
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                stattionId:n.stattionId,
                startLocation:n.lat+','+n.lng,
            }
        };
        getPoi(params).then((res)=>{
            if(res.data.code == '0000'){
                this.setState({poiList:res.data.data});
            }else{
                Toast.info(res.data.msg)
            }
        });
        setTimeout(()=> {
            this.autoFocusInst.focus();
        },500)
    }

    setData = (self, title, lng, lat, boolean, index) => {
        self.setState({
            endAddress: title,
            isError: boolean,
            curTips: index == 0 ? title : "坐标位置",
        });
        poi = {
            lng: lng,
            lat: lat,
            endAddress: title,
        };
    };

    goSelClass(){
        if(this.state.endAddress === '' || this.state.endAddress === '请拖动地图选点'){
            Toast.info("请输入下车地址！");
            return
        }
        const props = this.props.location.state;
        if(props.cityType === 'intercity'){
            this.intercityCheckRange(props)
        }else if(props.cityType === 'city'){
            this.cityGetPrice(props)
        }else if(props.cityType === 'cityChange'){
            this.cityChangeAddress(props)
        }else if(props.cityType === 'runCar'){
            this.runCheckRange(props)
        }
    }
    intercityCheckRange(props){
        let checkParams = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                startPosition:props.startPoi.lat + '_'+ props.startPoi.lng,
                endPosition:this.state.endAddress  == "昆明市" ? "25.082654_102.738151" : poi.lat + '_'+poi.lng,
            }
        };
        Toast.loading("");
        checkRange(checkParams).then((res)=>{
            if(res.data.code == "0000"){
                Toast.hide();
                if(poi.endAddress == '坐标位置'){
                    this.setState({endAddress:"坐标("+poi.lng + ','+poi.lat+")"});
                }
                let params = {
                    startCity:props.startCity,
                    startAddress:props.startPoi.address,
                    startPosition:props.startPoi.lat + '_'+ props.startPoi.lng,
                    endCity:this.state.currentEndCity,
                    endPosition:this.state.endAddress  == "昆明市" ? "25.082654_102.738151" : poi.lat + '_'+poi.lng,
                    endAddress:this.state.endAddress  == "昆明市" ? "民途出行北市区集散中心" : this.state.endAddress,
                    lineIds:res.data.data,
                    type:'address',
                };
                this.props.history.push('/selectShift',params);
            }else{
                Toast.info(res.data.msg)
            }
        });
    }
    cityGetPrice(props){
        let getPriceData = {
            source:1,
            token: this.props.userInfo.token,
            data: {
                startLocation:props.startPoi.lat + "_" + props.startPoi.lng,
                endLocation :this.state.endAddress == "昆明市"? "25.082654_102.738151" : poi.lat + "_" + poi.lng,
                cityId:props.cityId,
                cityorderType:props.nowType
            }
        };
        //获取价格
        cityGetPrice(getPriceData).then((res)=>{
            console.log(332,res);
            if(res.data.code == '0000'){
                let params = {
                    startCity:props.startCity,
                    startAddress:props.startPoi.address,
                    startPosition:props.startPoi,
                    endCity:props.startCity,
                    endPosition:poi,
                    endAddress:this.state.endAddress,
                    nowType:props.nowType,
                    appointmentTime:props.appointmentTime,
                    type:'address',
                    theoryPrice:res.data.data.totalPrice,
                    driverTime:res.data.data.driverTime,
                    driverDistance:res.data.data.driverDistance,
                    isFirstPay:res.data.data.isFirstPay,
                    cityId:props.cityId,
                    mark:true,
                };
                if(res.data.data === true){
                    Modal.alert('', <div>您有正在进行的城内订单，是否进入查看？</div>, [
                        { text: '取消',style:{background:"#DADCDE",color:"#ACACAC",fontSize:"14px",height:"48px"}},
                        { text: '进入',style:{background:"#3679FE",color:"#FFFFFF",fontSize:"14px",height:"48px"}, onPress: () => {
                                this.props.history.push('/rideCar');
                            }},
                    ]);
                }else{
                    if(res.data.data.isFirstPay == 1){
                        this.props.history.push('/rideCar',params);
                    }else{
                        this.props.history.push('/rideCarPay',params);
                    }
                }
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    cityChangeAddress(props){
        let changeData = {
            source:1,
            token: this.props.userInfo.token,
            data: {
                intercityOrderId :props.id,
                endAddress:this.state.endAddress,
                endAddressLocation  :this.state.endAddress == "昆明市" ? "25.082654_102.738151" : poi.lat + "_" + poi.lng,
                operatorType:3,
                sourceChange:3,
            }
        };
        changeAddress(changeData).then((res)=>{
            if(res.data.code == '0000'){
                this.props.history.push('/rideCar');
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    runCheckRange(props){
        let homeData={
            nowType:props.nowType,
            siteDate:props.siteDate,
            appointmentTime:props.appointmentTime,
            selAddress:poi,
        };
        let params={
            source:1,
            token:this.props.userInfo.token,
            data:{
                stationId:props.siteDate.id,
                location:poi.lat + '_' + poi.lng,
            }
        }
        shuttleCheckouts(params).then((res)=>{
            if(res.data.code == '0000'){
                sessionStorage.setItem('homeData',JSON.stringify(homeData));
                this.props.history.goBack();
            }else if(res.data.code == '9999'){
                Toast.info('不在接送范围内',2)
            }else{
                Toast.info(res.data.msg,2)
            }
        })
    }
    runChange(n){
        this.setData(this, '请拖动地图选点', '','', false, );
        // map.centerAndZoom(n,15);
        map.setCenter(new window.TMap.LatLng(n.location.lat,n.location.lng));
        setTimeout(()=> {
            this.autoFocusInst.focus();
            this.setState({national: false,currentEndCity:n.fullname,position:{},poiListFlag:true});
        },500)
    }
    render(){
        const props = this.props.location.state;
        const mapOptions = {
            loop: false,
            autoplay: true,
            animationData: mapData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return(
            <div className="selAddress">

                <div id="mapContainer"/>
                {
                    this.state.isError ? <div className="errTips"><span>{this.state.curTips}</span></div> : null
                }
                <img
                    className="userPosition"
                    src={userPosition}
                    style={{top: this.state.position.top, left: this.state.position.left}}
                    alt=""
                />
                <Lottie
                    style={{zIndex:'999',position:"absolute",bottom:"50%",left:"50%",marginLeft: -14}}
                    options={mapOptions}
                    height={52}
                    width={28}
                    isStopped={this.state.isStopped}
                    isPaused={this.state.isPaused}/>
                <div className="poiList" style={this.state.poiListFlag === false  ? {height:'0'} : {height:'100%'}} ref={dom => {this.tabDOM = dom}}>
                    <div>
                        <div className="history"><i className="icon iconfont iconlishi"/>历史记录</div>
                        {this.state.historyData && this.state.historyData.title !== "" ? <div className="historyText" onClick={() => this.selPoi(this.state.historyData)}>{this.state.historyData.title}</div> :<div className="historyText">暂无历史记录</div>}
                        <div className="mapSel" onClick={this.onClear}><i className="icon iconfont iconditushangxuandian"/>在地图上选点</div>
                    </div>
                    {
                        this.state.poiList.length > 0 ? (
                            <div className="list">
                                {
                                    this.state.poiList.map((res, i) => (
                                        <div className="item"  key={i}  onClick={() => this.selPoi(res)} >
                                            <i className="icon iconfont icondituliebiaotubiao"/>
                                            <div>
                                                <div>{res.title}</div>
                                                <span>{res.address}</span>
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>
                        ): <div className='tishi'>请输入搜索内容</div>
                    }

                </div>

                <div className="topBar">
                    <i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack("city")} />
                    {
                        props.cityType === 'city' || props.cityType === 'cityChange'?
                            <div className="selCity"><span>{props.startCity}</span></div> :
                            <div className="selCity" onClick={this.toggleCity}><span>{this.state.currentEndCity}</span><i className="icon iconfont iconxiala" /></div>
                    }
                    <SearchBar
                        className="searchBar"
                        value={this.state.searchValue}
                        placeholder={props.type === 'start' ? '哪儿上车？' : '哪儿下车？'}
                        onChange={this.searchChange}
                        showCancelButton={false}
                        ref={ref => this.autoFocusInst = ref}
                    />
                </div>
                <div className="bottom">
                   <div className="addressText">
                       {props.type === 'start' ? <i className="icon iconfont iconchufadi"/> : <i className="icon iconfont iconmudedi"/>}
                       <p>{this.state.endAddress}</p>
                   </div>
                    <div className="btn"><button onClick={()=>this.goSelClass()}>去打车</button></div>
                </div>

                <CityModal
                    modal={this.state.cityModal}
                    modalType={this.state.modalType}
                    onClose={this.onClose.bind(this)}
                    citySearch={this.state.citySearch}
                    data={this.state.cityData}
                    cityType = {this.props.location.state.cityType}
                    changeCity={this.changeCity.bind(this)}
                    getEndCityList={this.getEndCityList.bind(this)}
                    historyData={this.state.historyData}//热门地州
                    hotData={this.state.newHotData}//热门站点
                    nearbySite={""}//附近站点
                    {...this.props}
                />
                <NationalCity
                    modal={this.state.national}
                    onClose={this.onClose.bind(this)}
                    runChange={this.runChange.bind(this)}
                    {...this.props}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/SelAddress/index.js